import { Component, inject } from '@angular/core';
import { LoaderService } from '@core/services/common/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
  loaderService = inject(LoaderService);
}
